module.exports = __webpack_public_path__ + "img/Cyclist4.6ffede9d.png";